// @ts-check

/**
 * Extracts the points possible for each question in a set of question groups. The indices of the
 * returned array correspond to the questions in the groups.
 *
 * @param {{
 *   question_type: string,
 *   questions: {
 *     stimulus: string,
 *     title: string,
 *     type: string,
 *     explanation: string,
 *     validation: {
 *       scoring_type: string,
 *       valid_response: {
 *         score: number,
 *         value: string[],
 *       },
 *     }
 *   }[]
 * }[]} questionGroups - The question groups containing questions with validation data.
 * @returns {number[]} The points possible for each question in the groups.
 */
export function extractPointsPossible(questionGroups) {
  return questionGroups.reduce(function (/** @type {number[]} */accumulator, group) {
    group.questions.forEach(function (question) {
      var validation = question.validation;
      if (!validation || !validation.valid_response) {
        accumulator.push(1);
        return;
      }
      var score = validation.valid_response.score;
      accumulator.push(score || 1);
    });
    return accumulator;
  }, []);
}